import React, { useEffect, useState } from "react";
import { generateUUID } from "../utils/uuid";

export const useRegisterSection = (
	registerCallback: (sectionId: string) => void,
) => {
	const [isRegistered, setIsRegistered] = useState(false);
	const [sectionId] = useState(generateUUID().slice(0, 8));
	useEffect(() => {
		if (!isRegistered) {
			setIsRegistered(true);
			registerCallback(sectionId);
		}
	}, [isRegistered, registerCallback, sectionId]);

	return sectionId;
};
